import { render, staticRenderFns } from "./notification-filter.vue?vue&type=template&id=1b9af9e2"
import script from "./notification-filter.vue?vue&type=script&lang=js"
export * from "./notification-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports